/**
 * Created by alex.y on 8/11/2017.
 */
import { Component, Input, OnInit } from "@angular/core";
import { Order } from "../../../../objects/orders/order";
import { BaseCalculatorTab } from "./baseCalculatorTab";
import { OrderItem } from "../../../../objects/orders/orderItem";
import { CalculatorHelper } from "../../../../common/helpers/calculatorHelper";
import { Router } from "@angular/router";
import { OrderOptions } from "../../../../objects/orders/orderOptions";
/**
 * Created by alex.y on 8/11/2017.
 */

@Component({
    selector: "usa-calc-tab",
    templateUrl: "./usaCalculator.component.html",
    moduleId: module.id.toString()
})
export class UsaCalculatorComponent extends BaseCalculatorTab implements OnInit {
    @Input()
    public orderItem: OrderItem;

    @Input()
    public currency: string;

    @Input()
    public order: Order;

    @Input()
    public clonedOrder: Order;

    @Input()
    public clonedOrderItem: OrderItem;

    public calculatorHelper = CalculatorHelper;

    public isVehicle: boolean = false;

    constructor(public router: Router) {
        super();
    }

    public ngOnInit(): void {
        if(this.order && this.order.Flag)
             this.isVehicle = this.order.Flag.hasFlag(OrderOptions.IsVehicle);

    }

}


// WEBPACK FOOTER //
// ./app/components/calculator/tabs/calculatorResults/usaCalculator.component.ts